import React from "react";
import ReactDOM from "react-dom";
import Landing from "./components/Landing";
import Graph from "./components/Graph";
import Timeline from "./components/Timeline";
import Footer from "./components/Footer";
import useHorizontal from "@oberon-amsterdam/horizontal/hook";
import useScrollInfo from "react-element-scroll-hook";
import { useEffect, useState, createRef } from "react";
import * as d3 from "d3";

window.onload = function () {
  var mountNode = document.getElementById("app");
  ReactDOM.render(<App />, mountNode);
};

export default function App() {
  const [container, setContainer] = useState();
  useHorizontal({ container });

  // const [scroll, setScroll] = useState();
  const tlRef = createRef();
  const [scrollAmount, setScrollAmount] = useState();
  const [scrollInfo, setScrollRef] = useScrollInfo();

  // let viewportWidth = d3.min([window.innerWidth, 1920]);
  // viewportWidth = d3.max([viewportWidth, 1000]);
  const viewportWidth = 1200;
  const width = viewportWidth * 16;

  const xScale = d3
    .scaleTime()
    .domain([new Date("2/29/2020"), new Date("3/18/2021")])
    .range([0, width]);

  useEffect(() => {
    setScrollAmount(tlRef.current?.getBoundingClientRect().x);
  }, [scrollInfo]);

  return (
    <div
      id="container"
      ref={(ref) => {
        setContainer(ref);
        setScrollRef(ref);
      }}
    >
      <Landing />
      <Graph x={xScale} scrollAmount={scrollAmount} />
      <Timeline x={xScale} width={width} ref={tlRef} />
      <Footer />
    </div>
  );
}
